<template>
  <div>
    <CCard>
      <CCardHeader>
        <h5>История генераций промокодов</h5>
      </CCardHeader>
      <CCardBody>
        <!-- Filters -->
        <CRow class="mb-3">
          <CCol sm="3">
            <CSelect
              :options="typeOptions"
              :value.sync="filters.type"
              style="margin-bottom: 0;"
              placeholder="Тип"
            />
          </CCol>
          <CCol sm="3">
            <CSelect
              :options="creatorOptions"
              :value.sync="filters.creator"
              style="margin-bottom: 0;"
              placeholder="Создатель"
            />
          </CCol>
          <CCol sm="3">
            <DatePicker
              v-model="filters.dateFrom"
              :language="datepicker.lang"
              :format="datepicker.format"
              input-class="form-control custom-datepicker"
              placeholder="Дата с" />
          </CCol>
          <CCol sm="3">
            <DatePicker
              v-model="filters.dateTo"
              :language="datepicker.lang"
              :format="datepicker.format"
              input-class="form-control custom-datepicker"
              placeholder="Дата по" />
          </CCol>
          <CCol sm="12" class="mt-2 d-flex align-items-end justify-content-end">
            <CButton color="primary" @click="applyFilters">Применить</CButton>
            <CButton color="secondary" class="ml-2" @click="resetFilters">Сбросить</CButton>
          </CCol>
        </CRow>
        
        <CDataTable
          :items="list"
          :fields="fields"
          :items-per-page="itemsPerPage"
          :loading="loading"
          hover
          pagination
          @row-clicked="viewDetails"
        >
          <template #created_at="{ item }">
            <td>
              {{ formatDate(item.created_at) }}
            </td>
          </template>
          <template #administrator="{ item }">
            <td>
              {{ item.administrator ? item.administrator.email : '' }}
            </td>
          </template>
          <template #type="{ item }">
            <td>
              {{ item.type === 'mass' ? 'Массовая' : 'Персональная' }}
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import moment from 'moment';
import { ITEMS_PER_PAGE } from '@/utils/views';
import DatePicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'PromocodeHistory',
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      itemsPerPage: ITEMS_PER_PAGE,
      filters: {
        type: null,
        dateFrom: null,
        dateTo: null,
        creator: null
      },
      typeOptions: [],
      creatorOptions: [],
      fields: [
        { key: 'id', label: 'ID', sortable: false },
        { key: 'description', label: 'Описание', sortable: false },
        { key: 'count', label: 'Количество', sortable: false },
        { key: 'type', label: 'Тип', sortable: false },
        { key: 'created_at', label: 'Дата создания', sortable: false },
        { key: 'administrator', label: 'Создатель', sortable: false }
      ],
      datepicker: {
        lang: ru,
        format: 'dd.MM.yyyy',
        dateFrom: null,
        dateTo: null,
      },
    };
  },
  computed: {
    activePage: {
      get() {
        return parseInt(this.$route.query.page) || 1;
      },
      async set(v) {
        const query = { 
          page: v,
          ...this.getQueryFilters()
        };
        this.$router.push({ query });
      },
    },
  },
  watch: {
    activePage: 'fetchList',
    '$route.query': {
      handler(query) {
        // Update filters from URL without applying them
        this.filters.type = query.type || '';
        this.filters.dateFrom = query.dateFrom || '';
        this.filters.dateTo = query.dateTo || '';
        this.filters.creator = +query.creator || '';
      },
      immediate: true
    }
  },
  async created() {
    // Remove debounce as we only apply filters on button click
    await this.fetchFilterOptions();
    await this.fetchList();
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    getQueryFilters() {
      const filters = {};
      if (this.filters.type) filters.type = this.filters.type;
      if (this.filters.dateFrom) filters.dateFrom = this.filters.dateFrom ? moment(this.filters.dateFrom).format('YYYY-MM-DD') : null;
      if (this.filters.dateTo) filters.dateTo = this.filters.dateTo ? moment(this.filters.dateTo).format('YYYY-MM-DD') : null;
      if (this.filters.creator) filters.creator = +this.filters.creator;
      return filters;
    },
    applyFilters() {
      const query = { 
        page: 1,
        ...this.getQueryFilters()
      };
      this.$router.push({ query });
      this.fetchList();
    },
    resetFilters() {
      this.filters = {
        type: null,
        dateFrom: null,
        dateTo: null,
        creator: null
      };
      this.$router.push({ query: { page: 1 } });
      this.fetchList();
    },
    async fetchFilterOptions() {
      try {
        const response = await this.axios.get('/promocodes/generations/filter-options');
        
        // Process types
        this.typeOptions = response.data.types;
        
        // Process creators
        this.creatorOptions = response.data.administrators;
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка при загрузке опций фильтров');
        console.error(error);
      }
    },
    async fetchList() {
      this.loading = true;
      const params = { 
        page: this.activePage, 
        pageSize: this.itemsPerPage,
        ...this.getQueryFilters()
      };
      
      try {
        const response = await this.axios.get('/promocodes/generations/history', { params });
        this.list = response.data.results;
        this.total = Math.ceil(response.data.total / this.itemsPerPage);
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка при загрузке истории генераций');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    viewDetails(item) {
      this.$router.push(`/promocodes/history/${item.id}`);
    }
  }
};
</script>

<style scoped>
.table th, .table td {
  vertical-align: middle;
}
</style> 